import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import DealerBrandingImageTextField from './DealerBrandingImageTextField';
import themes from 'utils/themes/list';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const DealerBrandingComponent = ({
  logoFileRef,
  smallLogoFileRef,
  onLogoFileSelected,
  logoFileName,
  smallLogoFileName,
  brandingData,
  onThemeChange,
  logo,
  smallLogo,
  onDealerChange,
  dealer,
  dealers,
  validation
}) => {
  const { t } = useTranslation();
  const uploadClick = useCallback(ref => {
    ref.current.value = '';
    ref.current.click();
  }, []);

  return (
    <>
      <input
        id='logo-file-input'
        type='file'
        accept='image/*'
        style={{ display: 'none' }}
        ref={logoFileRef}
        onChange={onLogoFileSelected}
      />
      <input
        id='small-logo-file-input'
        type='file'
        accept='image/*'
        style={{ display: 'none' }}
        ref={smallLogoFileRef}
        onChange={e => onLogoFileSelected(e, true)}
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Autocomplete
            fullWidth
            name='dealers'
            value={dealer.id}
            valueKey='partnerId'
            labelKey='partnerName'
            label={t('Branding.PartnerName')}
            options={dealers}
            onChange={onDealerChange}
            simpleValue={true}
            error={!isValid(validation.dealerId)}
            helperText={getErrors(validation.dealerId)}
          />
        </Grid>
        <Grid item xs={11} md={6}>
          <DealerBrandingImageTextField
            name={'logo'}
            label={t('Branding.LogoPicture')}
            value={logoFileName}
            hasLogo={brandingData.hasLogo}
            imageSource={logo()}
            alt={'logo'}
            onUploadClick={() => uploadClick(logoFileRef)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Autocomplete
            fullWidth
            name='applicationTheme'
            value={brandingData.themeName}
            valueKey='themeName'
            labelKey='themeName'
            label={t('Branding.ApplicationTheme')}
            options={themes}
            onChange={onThemeChange}
            simpleValue={true}
          />
        </Grid>
        <Grid item xs={11} md={6}>
          <DealerBrandingImageTextField
            name={'small-logo'}
            label={t('Branding.SmallLogoPicture')}
            value={smallLogoFileName}
            hasLogo={brandingData.hasSmallLogo}
            imageSource={smallLogo()}
            alt={'small logo'}
            onUploadClick={() => uploadClick(smallLogoFileRef)}
          />
        </Grid>
      </Grid>
    </>
  );
};

DealerBrandingComponent.propTypes = {
  onLogoFileSelected: PropTypes.func.isRequired,
  logoFileRef: PropTypes.object,
  smallLogoFileRef: PropTypes.object,
  logoFileName: PropTypes.string,
  smallLogoFileName: PropTypes.string,
  brandingData: PropTypes.object,
  onThemeChange: PropTypes.func.isRequired,
  logo: PropTypes.func,
  smallLogo: PropTypes.func,
  userInfo: PropTypes.object,
  onDealerChange: PropTypes.func.isRequired,
  dealer: PropTypes.object.isRequired,
  dealers: PropTypes.array.isRequired,
  validation: PropTypes.object
};

export default DealerBrandingComponent;
